import React from 'react';

import HourItem from '@r1-frontend/service-engineer-visit/components/HourItem';
import { THour } from '@r1-frontend/service-engineer-visit/reducer/initialState';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { WithSkeleton } from '@r1-frontend/ui-react/components/loaders/Skeleton';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import * as S from './styled';

type TTimeSelectionProps = {
    timeList: THour[],
    handleSelectHour: (hour: string) => () => void,
    selectedHour?: string,
}

const TimeSelection = ({ timeList, handleSelectHour, selectedHour }: TTimeSelectionProps): JSX.Element => {
    const isMobile = useMatchMedia(`(max-width: ${wideBreakpoints.mobile})`);

    return (
        <S.Block>
            <H4 $smaller>Время</H4>
            <WithSkeleton width={isMobile ? 300 : '100%'} height={114} inline>
                <S.HoursWrapper>
                    {timeList.map((hour: THour) => (
                        <HourItem
                            key={`timeSlots-time-${hour.from}-${hour.to}`}
                            onClick={handleSelectHour(hour.from)}
                            from={hour.from}
                            to={hour.to}
                            disabled={!hour.active}
                            $selected={Boolean(hour.from === selectedHour)}
                            cost={hour.cost}
                        />
                    ))}
                </S.HoursWrapper>
            </WithSkeleton>
        </S.Block>
    );
};

export default TimeSelection;
